import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api-client';

/** The one definition of this read: the loader and the hook share its key. */
export function versionOptions() {
  return api.queryOptions('get', '/version');
}

/** The API surface this build talks to: its name and its version. */
export function useApiVersion() {
  return useQuery(versionOptions());
}
